(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hanogram-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-hero-slideshow')) {
  customElements.define('hg-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.slides = [...this.querySelectorAll('[data-hg-slide]')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.interval = Math.max(2000, Number(this.dataset.interval) || 5000);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.editorSelected = false;
      this.track = this.querySelector('.hg-slideshow__track');
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
        this.paused = true;
        this.show(index);
      }, options));
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.sync();
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.sync(); }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('touchstart', event => {
        this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.sync(); }, options);
      this.querySelector('.hg-slideshow__controls').hidden = false;
      this.setAttribute('data-ready', '');
      this.show(0);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const running = !this.paused && !this.hovered && !this.focused && !this.editorSelected && !document.hidden;
      this.track.setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.abort) this.abort.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hanogram-mobile-menu"]) return;
  try {
    
(() => {
  const menu = document.getElementById('han-mobile-menu');
  if (!menu || typeof menu.showModal !== 'function') return;
  const mobile = window.matchMedia('(max-width:767px)');
  let opener;
  let priorOverflow;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.mainmenumob-js');
    if (!trigger || !mobile.matches) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (menu.open) return;
    opener = trigger;
    priorOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    menu.showModal();
    menu.querySelector('.han-menu__close').focus();
  }, true);
  menu.querySelector('.han-menu__close').addEventListener('click', () => menu.close());
  menu.addEventListener('click', event => {
    if (event.target !== menu) return;
    const box = menu.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) menu.close();
  });
  menu.addEventListener('close', () => {
    document.body.style.overflow = priorOverflow || '';
    if (opener) opener.focus();
  });
  menu.querySelector('select').addEventListener('change', event => {
    if (event.target.value) window.location.assign(event.target.value);
  });
  mobile.addEventListener('change', () => { if (!mobile.matches && menu.open) menu.close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
